import { render } from "./SizeControl.vue?vue&type=template&id=adc6c048"
import script from "./SizeControl.vue?vue&type=script&lang=ts"
export * from "./SizeControl.vue?vue&type=script&lang=ts"
script.render = render

export default script